import { FormLabel, Group, Item, SearchForm } from 'mailup-web-components'
import {
  resetSearchCallback,
  searchWorkflowsCallback
} from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'
import {
  InputMessages,
  InputSearchString,
  InputStatus,
  InputTags,
  InputType
} from './components'

const Search = () => {
  const intl = useIntl()
  const [expanded, setExpanded] = useState(false)
  const fetchResults = useRecoilCallback(searchWorkflowsCallback, [])
  const resetSearch = useRecoilCallback(resetSearchCallback, [])

  const handleSubmit = () => {
    fetchResults()
  }

  const handleReset = () => {
    resetSearch()
  }

  const AdvancedSearchComponent = () => <AdvancedSearch />

  return (
    <SearchForm
      advanced
      labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
      labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
      expanded={expanded}
      AdvancedSearchComponent={AdvancedSearchComponent}
      onClickToggle={() => setExpanded((prev) => !prev)}
      onClickReset={handleReset}
      onSubmit={handleSubmit}
      submitClassName='test-searchButton'
      resetClassName='test-resetButton'
    >
      <Group>
        <Item>
          <InputSearchString onEnter={handleSubmit} />
        </Item>
      </Group>
    </SearchForm>
  )
}

const AdvancedSearch = ({ onInputChange }) => {
  const intl = useIntl()

  return (
    <>
      <Group of={3}>
        <Item>
          <InputTags />
        </Item>
      </Group>
      <Group of={3}>
        <FormLabel>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.TitleSearchConditionStatus'
          })}
        </FormLabel>
        <Item>
          <InputStatus />
        </Item>
      </Group>
      <Group of={3}>
        <FormLabel>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.TitleSearchType'
          })}
        </FormLabel>
        <Item>
          <InputType />
        </Item>
      </Group>
      <Group wide>
        <Item>
          <InputMessages />
        </Item>
      </Group>
    </>
  )
}

AdvancedSearch.propTypes = {
  onInputChange: PropTypes.func
}

export default Search
